import '@spectrum-web-components/styles/core-global.css';

(async () => {
  await import('@spectrum-web-components/theme/sp-theme.js');
  await import('@spectrum-web-components/theme/src/themes.js');
})();
